import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { TAssetsCarousel } from './models';
import styles from './styles.css';

export const AssetsCarousel: FC<TAssetsCarousel> = ({
    Card,
    analytics,
    assetCardTheme,
    assets,
    baseUrlToAsset,
    className,
}) => {
    const onClickAsset = (assetName: string) => () => {
        sendEvent({ ...analytics?.clickOnAsset, label_detail: assetName });
    };

    return (
        <div className={cn(styles.external, styles.assetsCarousel, className)}>
            {assets.map(asset => (
                <Card
                    key={asset.ISIN}
                    asset={asset}
                    baseUrlToAsset={baseUrlToAsset}
                    className={cn(styles.external, styles.cardMargin)}
                    dataTestId={`carousel-card-${asset.ISIN}`}
                    onClickAsset={onClickAsset}
                    theme={assetCardTheme}
                />
            ))}
        </div>
    );
};
